import { render, staticRenderFns } from "./batchReview.vue?vue&type=template&id=67664b90"
import script from "./batchReview.vue?vue&type=script&lang=ts"
export * from "./batchReview.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports